import { GoogleOAuthProvider } from "@react-oauth/google";
import { I18nextProvider } from "react-i18next";
import i18n from '../i18n'
import App from "../App";
import { Provider, useDispatch, useSelector } from "react-redux"
import React, { Suspense, useEffect, useState } from "react";
import { store } from "../redux/store";
import axios from "axios";
import _ from "lodash";
import CONFIG from "./config";
import { setGoogleClientId } from "../redux/home/actions";

const XselProvider = () => {

  const loginLogo = useSelector((state) => state.home.loginLogo);

  const googleClientId = useSelector((state) => state.home.googleClientId);

  const [googleKey, setGoogleKey] = useState("")  //1090402321229-vfidk0h1ujfabt9t1op50a6urhcmn990.apps.googleusercontent.com



  useEffect(()=>{
          if(!_.isEmpty(googleClientId)){
            setGoogleKey(googleClientId);
          }
  },[googleClientId])

  return (
    <GoogleOAuthProvider clientId={googleKey}>  {/* "17576881175-1is93c3agp0l4u371271592243bqpohk.apps.googleusercontent.com" */}

      <Suspense fallback={<div></div>}>
        {/* <React> */}
        <I18nextProvider i18n={i18n}>
          <React.StrictMode>
            <App />
          </React.StrictMode>
        </I18nextProvider>
        {/* </React> */}
      </Suspense>
    </GoogleOAuthProvider>
  );
}

export default XselProvider